var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.126028 7.39508L9.08687 13.4743C9.26529 13.5956 9.49708 13.456 9.49708 13.2274L8.75228 7.76165C8.68704 7.28452 8.68853 6.7988 8.75574 6.32222L9.49708 1.06953C9.49708 0.840892 9.26529 0.70135 9.08687 0.822644L0.126028 6.90185C-0.0420098 7.01509 -0.0420098 7.28076 0.126028 7.39508Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackarrow);
export default __webpack_public_path__ + "static/media/backarrow.166f20dbb02d2a5dc4768f547dbf966b.svg";
export { ForwardRef as ReactComponent };